import { render, staticRenderFns } from "./SubTotalItem.vue?vue&type=template&id=b88dd852&scoped=true&"
import script from "./SubTotalItem.vue?vue&type=script&lang=js&"
export * from "./SubTotalItem.vue?vue&type=script&lang=js&"
import style0 from "./SubTotalItem.vue?vue&type=style&index=0&id=b88dd852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88dd852",
  null
  
)

export default component.exports